import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const AddUserIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <Path
      stroke="#0058AD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15 13.6a4.712 4.712 0 0 0-1-.1H8a5 5 0 0 0-5 5v1s2 2 8 2a22 22 0 0 0 3-.19c.35 0 .69-.1 1-.17m2-3.64h4m-2-2v4m-3-11a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    />
  </Svg>
);
export default AddUserIcon;
